<template>
  <EditPanel class="cx_auditLog">
    <template slot="left">
      <div class="cx_auditLog_header"><span>更新履歴</span><div><a :href="ownLink" v-if="ownLink">ページリンク</a></div></div>
      <Grid storageKey="audit_logs" :items="items" :isLoading="isLoading" @selected="onSelected" :captions="['更新日時', '区分', 'ユーザー']" :widths="[180, 120, 150]"  ref="parentList">
        <GridItem slot="col0" slot-scope="{ listItem }">{{ listItem.timeStamp | timestamp }}</GridItem>
        <GridItem slot="col1" slot-scope="{ listItem }">{{ listItem.type | auditTypes }}</GridItem>
        <GridItem slot="col2" slot-scope="{ listItem }">{{ listItem.userId | user }}</GridItem>
      </Grid>
    </template>
    <template slot="right">
      <div class="cx_auditLog_header"><span>変更内容</span></div>
      <Grid storageKey="audit_items" :items="auditItems" :isLoading="isLoading" :captions="['項目名', '変更前', '変更後']" :widths="[160, 180, 180]"  ref="childList">
        <GridItem slot="col0" slot-scope="{ listItem }">{{ listItem.path }}</GridItem>
        <GridItem slot="col1" slot-scope="{ listItem }">{{ listItem.before }}</GridItem>
        <GridItem slot="col2" slot-scope="{ listItem }">{{ listItem.after }}</GridItem>
      </Grid>
    </template>
  </EditPanel>
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class AuditLogList extends Vue {
  @Prop({ default: '' }) public auditName: string;
  @Prop({ default: '' }) public auditNo: string;

  public items: Common.AuditLog[] = new Array();
  public isLoading: boolean = false;

  public auditItems: Common.AuditItem[] = new Array();
  public ownLink:string = "";

  created() {
    this.$api.formatter.ensureListLoaded("auditSources").then(()=>{
      this.setOwnLink();
    });
  }
  mounted() {
    this.loadAuditLog();
  }

  setOwnLink(){
      this.ownLink = String.format(this.$api.formatter.formatByList(this.auditName, "auditSources"),this.auditNo);
  }
  //#region
  @Watch('auditName')
  onAuditNameChanged() {
    this.loadAuditLog();
    this.setOwnLink();
  }
  @Watch('auditNo')
  onAuditNoChanged() {
    this.loadAuditLog();
    this.setOwnLink();    
  }

  loadAuditLog() {
    this.auditItems = new Array();
    this.items = new Array();
    //auditLogをロードする

    if (this.auditName && this.auditNo){
      const query = new Common.AuditLogQuery();
      query.auditName = this.auditName;
      query.auditNo = this.auditNo;
      query.editorMode = true;
      query.isDescending = true;
      query.perPage = 0; //フルロード
      this.isLoading = true;

      this.$api.execute(query).then(obj => {
        this.items = (obj as Common.LoadResult).result;
        this.isLoading = false;
        //以下は$refsがundefinedでエラーが発生するためコメント。グリッド側で最初の行が選択されるので不要。
        // if (this.items.length > 0) (this.$refs.parentList as Components.Grid).select(0);

      });      
    }
  }

  onSelected(index: number) {
    this.auditItems = this.items[index].auditItems;
  }
}
</script>
<style lang="scss">
  .cx_auditLog{
    .cx_auditLog_header{
      display:flex;
      height: 29px;
      margin-bottom: 5px;
      align-items: flex-end;
      span{
        display:flex;
        width :100px;
      }
      div{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        a {
          margin-left:  20px;
          margin-bottom: 5px;
          font-size: 11px;        
        }
      }

    }
  .cx_editPanel_left {
    display:flex;
    flex-direction: column;
    height: unset !important;
  }
  .cx_editPanel_right { 
    display:flex;
    flex-direction: column;
    height: unset !important;
  }  
  }
</style>
